import { SET_CONTRACT_CLOSE, SET_CONTRACT_CODE, SET_CONTRACT_ID, SET_CONTRACT_LABEL, SET_LOCATION, SET_JOBSLAUNCH } from '../actionType';

export const initialState = {
  code: '',
  id: '',
  toClose: false,
  label:'',
  location:'',
  launchJob:{
    jobId:'',
    runId:'',
    isDatabricksJob: false,
  }
};

export const contracts = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_CONTRACT_CODE: {
      return { ...state, code: action.payload };
    }
    case SET_CONTRACT_ID: {
      return { ...state, id: action.payload };
    }
    case SET_CONTRACT_CLOSE: {
      return { ...state, toClose: action.payload };
    }
    case SET_CONTRACT_LABEL:{
      return {...state, label: action.payload };
    }
    case SET_LOCATION:{
      return {...state, location: action.payload };
    }
    case SET_JOBSLAUNCH:{
      return {...state, launchJob: action.payload };
    }
    default:
      return state;
  }
};
